import { Card } from "@devhop/ui";
import type { AuditSummaryStats } from "@/modules/internal-audit/domain/repo/summary/get-stats";

type AuditSummaryChartsProps = {
  stats: AuditSummaryStats;
};

export function AuditSummaryCharts({ stats }: AuditSummaryChartsProps) {
  const { overall } = stats;

  if (overall.totalAudits === 0) return null;

  const passRate = Math.round((overall.passCount / overall.totalAudits) * 100);
  const failRate = Math.round((overall.failCount / overall.totalAudits) * 100);
  const needsImprovementRate = Math.round(
    (overall.needsImprovementCount / overall.totalAudits) * 100,
  );

  return (
    <Card className="p-6" data-tourid="summary-charts">
      <h2 className="mb-4 font-semibold text-lg">ອັດຕາຜ່ານ/ບໍ່ຜ່ານ</h2>
      <div className="space-y-3">
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span className="text-green-600">ຜ່ານ</span>
            <span className="font-semibold">{passRate}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-green-500 transition-all"
              style={{ width: `${passRate}%` }}
            />
          </div>
        </div>
        <div>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span className="text-red-600">ບໍ່ຜ່ານ</span>
            <span className="font-semibold">{failRate}%</span>
          </div>
          <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-red-500 transition-all"
              style={{ width: `${failRate}%` }}
            />
          </div>
        </div>
        {needsImprovementRate > 0 && (
          <div>
            <div className="mb-1 flex items-center justify-between text-sm">
              <span className="text-yellow-600">ຕ້ອງປັບປຸງ</span>
              <span className="font-semibold">{needsImprovementRate}%</span>
            </div>
            <div className="h-6 w-full overflow-hidden rounded-full bg-muted">
              <div
                className="h-full bg-yellow-500 transition-all"
                style={{ width: `${needsImprovementRate}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}

